import * as React from 'react';

const scriptPath = '/web-component/gestao-amei';
const suffixes = ['.js', '.legacy.js'];

export interface QueryString {
  [key: string]: string;
}

interface GestaoAmeiUrl {
  initialized: boolean;
  entrypoint(paths: string[]): string;
  mountUrl(endpoint: string, queryString: QueryString): string;
}

function isNotEmpty(value: string): boolean {
  return !!value?.trim?.() ?? false;
}

const PATH_SEPARATOR = '/' as const;

export function useUrl(forceUrl?: string): GestaoAmeiUrl {
  const [baseUrl, setBaseUrl] = React.useState<string>();
  const [baseQueryString, setQueryString] = React.useState<string>();
  const initialized = React.useMemo(() => !!baseUrl, [baseUrl]);

  const entrypoint = React.useCallback(
    (paths: string[]) =>
      PATH_SEPARATOR + paths.filter(isNotEmpty).join(PATH_SEPARATOR),
    [],
  );

  const mountUrl = React.useCallback(
    (endpoint: string, queryString: QueryString) => {
      const queryStringSeparator = (condition: boolean) =>
        condition ? '?' : '&';

      const append = (url: string, [key, value]: string[]) =>
        `${url}${queryStringSeparator(!url.includes('?'))}` +
        `${key}=${encodeURIComponent(value)}`;

      const pairs = Object.entries(queryString);
      const url = pairs.reduce(append, baseUrl + endpoint);

      if (baseQueryString) {
        return (
          `${url}${queryStringSeparator(!url.includes('?'))}` + baseQueryString
        );
      }
      return url;
    },
    [baseUrl, baseQueryString],
  );

  React.useEffect(() => {
    if (forceUrl) {
      return setBaseUrl(forceUrl);
    }

    const src = document
      .querySelector<HTMLScriptElement>(`script[src*="${scriptPath}"]`)
      ?.src?.replace(new RegExp(`${scriptPath}(${suffixes.join('|')})`), '');

    if (typeof src !== 'string') {
      throw Error('[Gestão AMEI] não foi possível descobrir a URL');
    }

    const srcSplitted = src.split('?');
    setBaseUrl(srcSplitted?.[0]);
    setQueryString(srcSplitted?.[1]);
  }, [forceUrl]);

  return {
    initialized,
    entrypoint,
    mountUrl,
  };
}
